/* HARUM (HAR-249 / HAR-250): store directory rail, product carousels and the
   store page hero. No framework, no jQuery (Hyper has no global $).

   - Carousels scroll natively (scroll-snap); this only wires the arrows and
     hides them while everything fits.
   - A store-page carousel that needs a different sort than the page was
     rendered with carries data-harum-carousel-src: the sorted markup is
     fetched with Shopify's Section Rendering API when it scrolls into view
     and swapped in, so "Trending" and "Newest" can sit on one page.
   - The hero's "Have a link?" form is a plain GET to the Personal Shopper
     page (works without JS); here we just add https:// when it is missing so
     harum-personal-shopper.js recognises the value and starts its paste flow. */
(function () {
  'use strict';

  function wireScroller(root, trackSelector, prevSelector, nextSelector) {
    var track = root.querySelector(trackSelector);
    var prev = root.querySelector(prevSelector);
    var next = root.querySelector(nextSelector);
    if (!track || !prev || !next || track.dataset.harumScrollerReady) return;
    track.dataset.harumScrollerReady = '1';

    function step() {
      var first = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var fits = max <= 0;
      prev.hidden = fits || track.scrollLeft <= 0;
      next.hidden = fits || track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* Cards may still be loading images when this runs. */
    update();
    setTimeout(update, 400);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
  }

  function wireCarousel(carousel) {
    wireScroller(carousel, '[data-harum-carousel-track]', '[data-harum-carousel-prev]', '[data-harum-carousel-next]');
  }

  function wireRail(wrap) {
    wireScroller(wrap, '[data-harum-rail]', '[data-harum-rail-prev]', '[data-harum-rail-next]');
  }

  /* Store-page carousel rendered with the wrong sort: fetch the right one. */
  function hydrate(section) {
    var src = section.dataset.harumCarouselSrc;
    if (!src || section.dataset.harumHydrating) return;
    section.dataset.harumHydrating = '1';

    fetch(src, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-harum-carousel]');
        var current = section.querySelector('[data-harum-carousel]');
        if (!fresh || !current) throw new Error('no carousel in response');
        current.replaceWith(fresh);
        section.removeAttribute('data-harum-carousel-src');
        wireCarousel(fresh);
        /* Let the currency converter and quick-view pick the new cards up. */
        document.dispatchEvent(new CustomEvent('harum:carousel:loaded', { detail: { section: section } }));
      })
      .catch(function (error) {
        console.warn('[harum-store] could not load sorted products:', error);
        /* Keep the placeholders from lingering forever. */
        section.hidden = true;
      });
  }

  function watchLazy(sections) {
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach(hydrate);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: '400px 0px' }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function wireBuyForm(form) {
    if (form.dataset.harumBuyReady) return;
    form.dataset.harumBuyReady = '1';
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="add"]');
      if (!input) return;
      var value = input.value.trim();
      if (value && !/^https?:\/\//i.test(value)) input.value = 'https://' + value;
    });
  }

  function boot() {
    document.querySelectorAll('[data-harum-carousel]').forEach(wireCarousel);
    document.querySelectorAll('[data-harum-stores] .harum-stores__rail-wrap').forEach(wireRail);
    watchLazy(Array.prototype.slice.call(document.querySelectorAll('[data-harum-carousel-src]')));
    document.querySelectorAll('[data-harum-store-buy]').forEach(wireBuyForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();
